import { ActionTree, ActionContext } from 'vuex';
import { CompanyProfileState } from './CompanyProfileTypes';
import { RootState } from '@/app/shared/store/RootState';

export const actions: ActionTree<CompanyProfileState, RootState> = {

};
